/**
 * @class
 * @extends Netx.Model
 */
import Base from '@netx/core/lib/netx-model';

import Menu from '@netx/core/lib/netx-menu';
import {currentUserMeetsUserLevel} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {FindLegacyAction} from '@netx/core/legacyActionManager';

class OptionTile extends Base {
	/**
	 * @property {object}  defaults - The default attribute values
	 */
	get defaults() {
		return {
			action: '',
			event: '',
			icon: null,
			label: '',
			menu: null,
		};
	}

	/** @override */
	constructor(attr = {}, opts = {}) {
		super(attr, opts);

		// Action string
		if (_.isString(attr.action)) {
			// Innocent until proven guilty in a court of law
			let valid = true;
			// Get action object
			let action = FindLegacyAction(attr.action);

			// Unregistered action
			if (!action) {
				console.warn(
					'Could not locate an action for "' +
						attr.action +
						'". Ensure it has been registered view Netx.Action.Register.',
				);
				return;
			}

			// Run through enabler test(s)
			if (action.enableTest) {
				// We have multiple enabler tests
				if (_.isArray(action.enableTest)) {
					_.each(action.enableTest, (et) => {
						// If still valid
						if (valid && _.isFunction(et)) {
							// Hopefully you passed an object containing something that can be tested
							// TODO: update after DAM-6168 is fixed.
							valid = et(opts);
						}
					});
				}
				// Just a single enabler test
				else if (_.isFunction(action.enableTest)) {
					//valid = action.enableTest( opts );
					//
					// DAM-6168: this generally won't work.  EnableTests expect a view and an event as args.
					// Here's a hacking option for 8.5: see cart:relationships handler for the other end of the snake.
					if (opts.data && opts.data.view) {
						valid = action.enableTest(opts.data.view);
					} else {
						valid = action.enableTest(opts);
					}
				}
			}
			// Check user level
			if (action.userLevel && !currentUserMeetsUserLevel(action.userLevel)) {
				valid = false;
			}

			// All is good
			if (valid) {
				this.attributes = _.extend({}, this.attributes, action);
				// Additional 'payload' data
				// Useful for enablerTests and permissions checks
				this.attributes.data = opts.data;
			}
			return;
		}

		if (!(attr.action instanceof Menu)) {
			console.warn('Unknown action: ' + attr.action);
			return;
		}

		// Action menu
		this.attributes = _.extend({}, this.attributes, {
			// We just point the action back at 'app:optionTiles' which will take this model's menu object and keep going
			action: 'app:showOptions',
			event: 'app:showOptions',
			menu: attr.action,
			icon: attr.action.get('icon'),
			label: attr.action.get('label'),
		});
	}

	/** @type {string} */
	static get __name__() {
		return 'OptionTile';
	}
}

export default OptionTile;
